import Vue from 'vue'
import Router from 'vue-router'

import Navi from '../components/pc/pages/navi/Navi'

// 博客
import Blog from '../components/pc/pages/blog/Blog'
import BlogInfo from '../components/pc/pages/blog/BlogInfo'

// 留言板
import Message from '../components/pc/pages/message/Message'

// 电影
import Movie from '../components/pc/pages/movie/Movie'
import MovieInfo from '../components/pc/pages/movie/MovieInfo'
import MoviePersonnel from '../components/pc/pages/movie/MoviePersonnel'
import MovieRelated from '../components/pc/pages/movie/MovieRelated'
import MovieDepartment from '../components/pc/pages/movie/MovieDepartment'
import MovieDepartmentInfo from '../components/pc/pages/movie/MovieDepartmentInfo'

// 电视剧
import TVSeries from '../components/pc/pages/tvseries/TVSeries'
import TVSeriesInfo from '../components/pc/pages/tvseries/TVSeriesInfo'

// 动漫
import Comic from '../components/pc/pages/comic/Comic'
import ComicInfo from '../components/pc/pages/comic/ComicInfo'

// 学习
import Study from '../components/pc/pages/study/Study'

// 软件
import Software from '../components/pc/pages/software/Software'

// 简历
import Resume from '../components/pc/pages/resume/Resume'

// 关于
import About from '../components/pc/pages/about/About'
import Station from '../components/pc/pages/about/Station'
import Feedback from '../components/pc/pages/about/Feedback'
import Download from '../components/pc/pages/about/Download'

// 注册
import Register from '../components/pc/pages/register/Register'

// 后台管理
import BackManage from '../components/pc/pages/back/BackManage'
import BackDashboard from '../components/pc/pages/back/BackDashboard'
// 用户管理
import BackManageLogin from '../components/pc/pages/back/login/BackManageLogin'
import BackRegisterCodeManage from '../components/pc/pages/back/user/BackRegisterCodeManage'
// 博客管理
import BackAddBlog from '../components/pc/pages/back/blog/BackAddBlog'
import BackBlogManage from '../components/pc/pages/back/blog/BackBlogManage'
import BackBlogInfo from '../components/pc/pages/back/blog/BackBlogInfo'
// 电影管理
import BackAddMovie from '../components/pc/pages/back/movie/BackAddMovie'
import BackMovieManage from '../components/pc/pages/back/movie/BackMovieManage'
// 问题反馈
import BackFeedbackManage from '../components/pc/pages/back/feedback/BackFeedbackManage'

import Common from '../js/Common'

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Navi',
      component: Navi,
      children: [
        {
          path: '/blog',
          alias: '',
          component: Blog,
          name: 'Blog'
        },
        {
          path: '/message',
          alias: '',
          component: Message,
          name: 'Message'
        },
        {
          path: '/movie',
          alias: '',
          component: Movie,
          name: 'Movie'
        },
        {
          path: '/movie/department',
          alias: '',
          component: MovieDepartment,
          name: 'MovieDepartment'
        },
        {
          path: '/tvseries',
          alias: '',
          component: TVSeries,
          name: 'TVSeries'
        },
        {
          path: '/comic',
          alias: '',
          component: Comic,
          name: 'Comic'
        },
        {
          path: '/study',
          alias: '',
          component: Study,
          name: 'Study'
        },
        {
          path: '/software',
          alias: '',
          component: Software,
          name: 'Software'
        },
        {
          path: '/resume',
          alias: '',
          component: Resume,
          name: 'Resume'
        },
        {
          path: '/about',
          component: About,
          name: 'About',
          children: [
            {
              path: '/about/station',
              alias: '',
              component: Station,
              name: 'Contact'
            },
            {
              path: '/about/feedback',
              alias: '',
              component: Feedback,
              name: 'Feedback'
            },
            {
              path: '/about/download',
              alias: '',
              component: Download,
              name: 'Download'
            }
          ]
        },
        {
          path: '/register',
          alias: '',
          component: Register,
          name: 'Register'
        },
        {
          path: '/blog/blog_info',
          alias: '',
          component: BlogInfo,
          name: 'BlogInfo'
        },
        {
          path: '/movie/movie_info',
          alias: '',
          component: MovieInfo,
          name: 'MovieInfo'
        },
        {
          path: '/movie/department_info',
          alias: '',
          component: MovieDepartmentInfo,
          name: 'MovieDepartmentInfo'
        },
        {
          path: '/movie/personnel',
          alias: '',
          component: MoviePersonnel,
          name: 'MoviePersonnel'
        },
        {
          path: '/movie/related',
          alias: '',
          component: MovieRelated,
          name: 'MovieRelated'
        },
        {
          path: '/tvseries/tvseries_info',
          alias: '',
          component: TVSeriesInfo,
          name: 'TVSeriesInfo'
        },
        {
          path: '/comic/comic_info',
          alias: '',
          component: ComicInfo,
          name: 'ComicInfo'
        }

      ]
    },
    {
      path: '/back/login',
      alias: '',
      name: 'BackManageLogin',
      component: BackManageLogin
    },
    {
      path: '/back',
      name: 'BackManage',
      component: BackManage,
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: '/back/dashboard',
          alias: '',
          name: 'BackDashboard',
          component: BackDashboard,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/back/register_code_manage',
          alias: '',
          name: 'BackRegisterCodeManage',
          component: BackRegisterCodeManage,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/back/add_blog',
          alias: '',
          name: 'BackAddBlog',
          component: BackAddBlog,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/back/blog_manage',
          alias: '',
          name: 'BackBlogManage',
          component: BackBlogManage,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/back/blog_info',
          alias: '',
          name: 'BackBlogInfo',
          component: BackBlogInfo,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/back/add_movie',
          alias: '',
          name: 'BackAddMovie',
          component: BackAddMovie,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/back/movie_manage',
          alias: '',
          name: 'BackMovieManage',
          component: BackMovieManage,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/back/feedback_manage',
          alias: '',
          name: 'BackFeedbackManage',
          component: BackFeedbackManage,
          meta: {
            requireAuth: true
          }
        }

      ]
    }

  ],
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  // if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  //   window.location.href = './m_index.html#/'
  //   return
  // }
  // console.log(to.path)
  // console.log(from.path)

  // if (to.path === '/backmanage' || to.path === '/backmanage/') {
  //   next('/backmanage/login')
  //   return
  // }
  //
  // next()

  if (to.meta.requireAuth) {
    if (Common.isLogin()) {
      next()
    } else {
      // 跳转至登录
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js